// extracted by mini-css-extract-plugin
module.exports = {"Tab":"Tab_Tab__2dbA0","Inactive":"Tab_Inactive__td4qa","Active":"Tab_Active__2Ixoj"};